import { PaymentOption } from '@/modules/checkout/_core/domain/entities'

export const TABS = [
  PaymentOption.CreditCard,
  PaymentOption.BankSlip,
  PaymentOption.Pix,
]
